import { Component, Input, OnInit } from '@angular/core';
import { VariablesService } from '../../services/variables.service';
import { RegistrationService } from 'src/app/services/registration.service';
import { ControlContainer, NgForm } from '@angular/forms';
import { ListManagerService } from 'src/app/services/list-manager.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-guest-variables',
  templateUrl: './guest-variables.component.html',
  styleUrl: './guest-variables.component.scss',
  viewProviders: [{provide: ControlContainer, useExisting: NgForm}]
})
export class GuestVariablesComponent implements OnInit {
  @Input() guest: any;
  @Input() reason: any;

  langinterp;
  guestCity;
  guestState;
  stateList;
  nuerdiv;
  foodAllergiesList;
  gCity;

  constructor(
    private variablesService: VariablesService,
    private registrationService: RegistrationService,
    private listService: ListManagerService,
  ){}
  ngOnInit(): void {
    this.langinterp = this.registrationService.getVariable(
      this.guest,
      this.variablesService.VARIABLE.LANGUAGE_INTERPRETER.ID,
      {}
    );
    this.guestCity = this.registrationService.getVariable(
      this.guest,
      this.variablesService.VARIABLE.GUEST_CITY.ID,
      {}
    );
    this.guestState = this.registrationService.getVariable(
      this.guest,
      this.variablesService.VARIABLE.GUEST_STATE.ID,
      {}
    );
    this.listService.getStateList().then(list => {
      this.stateList = list;
    });
    this.nuerdiv = this.registrationService.getVariable(
      this.guest,
      this.variablesService.VARIABLE.NUERODIVERSITY_CONSIDERATIONA.ID,
      {}
    );
    this.foodAllergiesList = [
      { code: "Dairy", name: "Dairy" },
      { code: "Eggs", name: "Eggs" },
      { code: "Peanuts", name: "Peanuts" },
      { code: "Tree Nuts", name: "Tree Nuts (almonds/cashews/walnuts)" },
      { code: "Fish", name: "Fish (bass/cod/flounder)" },
      { code: "Shellfish", name: "Shellfish (crab/lobster/shrimp)" },
      { code: "Soy", name: "Soy" },
      { code: "Wheat", name: "Wheat" },
      { code: "Other", name: "Other" }
    ];
    if(!this.guest.$mtcAllergens) {
      this.guest.$mtcAllergens = [];
    }
    
  }

  includes(arr, val) {
    return _.includes(arr, val);
  }

  allergyUpdate(allergy){
    let justadded = false;

    if (!_.includes(this.guest.$mtcAllergens, allergy.code)) {
      this.guest.$mtcAllergens.push(allergy.code);
      justadded = true;
    }
    if (justadded === false && _.includes(this.guest.$mtcAllergens, allergy.code)) {
      var index = this.guest.$mtcAllergens.indexOf(allergy.code);
      if (index !== -1) {
        this.guest.$mtcAllergens.splice(index, 1);
      }
    }
  }

  setGuestCity(gCity){
    const words = gCity.split(" ");
    let word = '';
    for (let i = 0; i < words.length; i++) {
      //words[i] = words[i][0].toUpperCase() + words[i].substr(1);
      word = words[i][0].toUpperCase()
      for(let j=1; j<words[i].length; j++){
        word = word + words[i][j].toLowerCase()
      }
        words[i] = word;
    }
    gCity = words.join(" ")
    this.guestCity.Value = gCity;
  }


}
